import { createContext, useContext } from "react";

const PayrollFormContext = createContext();

export const PayrollFormProvider = ({ children, value }) => {
  return (
    <PayrollFormContext.Provider value={value}>
      {children}
    </PayrollFormContext.Provider>
  );
};

export const usePayrollForm = () => {
  const context = useContext(PayrollFormContext);

  if (!context) {
    throw new Error(
      "usePayrollForm must be used inside PayrollFormProvider"
    );
  }

  return context;
};